import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Leaf, Shield, Cpu } from 'lucide-react';
import innovativeImage from '../../assets/images/Innovative-Solutions.jpg';

const InnovativeSolutions = () => {
  const solutions = [
    {
      icon: <Package size={24} />,
      title: 'Integrated Shipping Solutions',
      description: 'A unified platform combining shipping, inventory, and logistics for better efficiency.',
    },
    {
      icon: <Leaf size={24} />,
      title: 'Sustainability-Focused Practices',
      description: 'Eco-friendly, carbon-neutral processes to reduce logistics environmental impact.',
    },
    {
      icon: <Shield size={24} />,
      title: 'Safety and Compliance',
      description: 'Strict safety protocols to protect employees and stakeholders.',
    },
    {
      icon: <Cpu size={24} />,
      title: 'Technological Innovation',
      description: 'Advanced tech to optimize operations and improve service reliability.',
    },
  ];

  return (
    <section className="section-y bg-lightGray">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-stretch">
          {/* Left Side - Full Image */}
          <div className="order-2 lg:order-1 min-h-[240px] lg:min-h-[420px]">
            <div className="relative h-full min-h-[inherit] rounded-2xl overflow-hidden shadow-card-hover border border-slate-200/80">
              <img 
                src={innovativeImage}
                alt="Innovative Solutions"
                className="w-full h-full min-h-[240px] lg:min-h-[420px] object-cover"
              />
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="order-1 lg:order-2 flex flex-col justify-center">
            <div className="mb-6">
              <span className="section-kicker">Why choose us</span>
              <h2 className="text-3xl md:text-4xl font-bold text-navy tracking-tight mt-0 mb-4">
                Our Innovative Solutions
              </h2>
              <div className="w-16 h-1 bg-teal rounded-full mb-6" aria-hidden />
              <p className="text-darkGray/70 leading-relaxed">
                We combine cutting-edge technology with industry expertise to deliver innovative solutions that drive efficiency, sustainability, and reliability in maritime operations.
              </p>
            </div>

            {/* Solutions List */}
            <div className="space-y-6 mt-8">
              {solutions.map((solution, index) => (
                <div key={index} className="flex gap-4 group">
                  <div className="flex-shrink-0">
                    <div className="bg-gradient-to-br from-navy to-teal p-2 rounded-lg text-white group-hover:scale-110 transition-transform duration-300">
                      {solution.icon}
                    </div>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-navy mb-2">
                      {solution.title}
                    </h3>
                    <p className="text-darkGray/70 text-sm leading-relaxed">
                      {solution.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <Link 
              to="/contact"
              className="mt-8 inline-flex items-center gap-2 rounded-lg bg-navy px-6 py-3 text-sm font-semibold text-white shadow-card transition-colors duration-300 hover:bg-teal focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal group w-fit"
            >
              Discover more
              <span className="group-hover:translate-x-1 transition-transform" aria-hidden>→</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InnovativeSolutions;